import React from 'react';
import {
  TextField,
  Box,
  Typography,
  Button,
  CircularProgress,
  IconButton,
} from '@mui/material';
import { HelpOutlineOutlined as HelpOutlineOutlinedIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface KustoQueryFormProps {
  query: string;
  onQueryChange: (query: string) => void;
  onExecuteQuery: () => void;
  isExecuting: boolean;
  availableColumns: string[];
  queryError?: string;
  solutionId: string;
  isEditMode?: boolean;
  onClearChartConfig?: () => void;
}
export const KustoQueryForm: React.FC<KustoQueryFormProps> = ({
  query,
  onQueryChange,
  onExecuteQuery,
  isExecuting,
  availableColumns,
  queryError,
  solutionId,
  isEditMode = false,
  onClearChartConfig,
}) => {
  const navigate = useNavigate();

  const handleExecuteQuery = () => {
    if (isEditMode === true && onClearChartConfig) {
      onClearChartConfig();
    }
    onExecuteQuery();
  };
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Data Access API Documentation
        </Typography>
        <IconButton
          size="small"
          title="Help center"
          onClick={() =>
            navigate('/help-center/docs/IndustrialSetup/DataAccess/')
          }
        >
          <HelpOutlineOutlinedIcon fontSize="small" />
        </IconButton>
      </Box>

      <TextField
        label="API Endpoint"
        value={`/api/v1/data/solutions/${solutionId}/tenants/1/executerawkustoquery`}
        placeholder="API endpoint for Kusto queries"
        fullWidth
        multiline
        rows={2}
        InputProps={{
          readOnly: true,
          style: {
            fontSize: '13px',
            fontFamily: 'monospace',
            lineHeight: '1.2',
            padding: '8px 12px',
          },
        }}
        sx={{
          '& .MuiInputBase-root': {
            padding: 0,
          },
          '& .MuiInputBase-input': {
            padding: '8px 12px',
          },
        }}
        disabled
      />

      <TextField
        label="Kusto Query"
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
        placeholder="Enter your Kusto query here..."
        multiline
        rows={6}
        fullWidth
        error={!!queryError}
        helperText={queryError}
        sx={{
          '& .MuiInputBase-input': {
            padding: '8px 12px',
          },
        }}
      />

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <Button
          variant="contained"
          onClick={handleExecuteQuery}
          disabled={!query.trim()}
          sx={{ minWidth: 200 }}
          // startIcon={isExecuting ? <CircularProgress size={16} /> : null}
        >
          Execute Kusto Query
        </Button>
        {/* {availableColumns.length > 0 && (
          <Typography variant="body2" color="text.secondary">
            Available columns: {availableColumns.length}
          </Typography>
        )} */}
      </Box>
    </>
  );
};
